import React from 'react';

import { connect } from 'react-redux';

import Panel from '../../../../object-view/objects/panel';
import Screw from '../../../../object-view/objects/screw/screw';
import { setScrewOptions } from '@reducers/options/screw/actions';
import { setSlottedHolesActiveBtn } from '@reducers/selectors/dimension/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { getTooltip} from '../../../../../src/texts/tooltips';
import { Tooltip } from '@components/Tippy';


const buttonsFirst = [{
  
  id: '1',
  img: 'icon_dimensions-slottedholes-6',
  tooltip: "TT141", //APP_TOOLTIPS.TOOLTIP_NO_SLOTTED_HOLES_SPECIFIED.Content,
  config: []
}, {
  id: '2',
  img: 'icon_dimensions-slottedholes-7',
  tooltip: "TT142", //APP_TOOLTIPS.TOOLTIP_SLOTTED_HOLES_SPECIFIED.Content,
  config: [{
    index: 2,
    type: Screw.types.LONG_Y
  }]
}, {
  id: '3',
  img: 'icon_dimensions-slottedholes-8',
  tooltip:"TT142", //APP_TOOLTIPS.TOOLTIP_SLOTTED_HOLES_SPECIFIED.Content,
  config: [{
    index: 1,
    type: Screw.types.LONG_Y
  }]
}];

const buttonsSecond = [{
  id: '1',
  img: 'icon_dimensions-slottedholes-1',
  tooltip:"TT141", //APP_TOOLTIPS.TOOLTIP_NO_SLOTTED_HOLES_SPECIFIED.Content,
  config: []
}, {
  id: '2',
  img: 'icon_dimensions-slottedholes-2',
  tooltip:"TT142", //APP_TOOLTIPS.TOOLTIP_SLOTTED_HOLES_SPECIFIED.Content,
  config: [{
    index: 2,
    type: Screw.types.LONG_X
  }, {
    index: 4,
    type: Screw.types.LONG_X
  }]
}, {
  id: '3',
  img: 'icon_dimensions-slottedholes-3',
  tooltip:"TT142",//APP_TOOLTIPS.TOOLTIP_SLOTTED_HOLES_SPECIFIED.Content,
  config: [{
    index: 1,
    type: Screw.types.LONG_X
  }, {
    index: 3,
    type: Screw.types.LONG_X
  }]
}, {
  id: '4',
  img: 'icon_dimensions-slottedholes-4',
  tooltip:"TT142", //APP_TOOLTIPS.TOOLTIP_SLOTTED_HOLES_SPECIFIED.Content,
  config: [{
    index: 1,
    type: Screw.types.LONG_Y
  }, {
    index: 2,
    type: Screw.types.LONG_Y
  }]
}, {
  id: '5',
  img: 'icon_dimensions-slottedholes-5',
  tooltip:"TT142", //APP_TOOLTIPS.TOOLTIP_SLOTTED_HOLES_SPECIFIED.Content,
  config: [{
    index: 3,
    type: Screw.types.LONG_Y
  }, {
    index: 4,
    type: Screw.types.LONG_Y
  }]
}];

const SlottedHoles = props => (
  <div className="calculation">
    <section className="list-type">
      { (props.type === Panel.types.SQUARE && ((props.screw.count.m === 1 || props.screw.count.m === 2) && props.screw.count.n === 2)) && (
        <div>
          { (props.screw.count.m === 1 && props.screw.count.n === 2) && (
            <ul className="inline-list">
              {buttonsFirst.map(item => (
              <li key={item.id}>
                <Tooltip content={getTooltip(item.tooltip)}>
                  <button
                    className={`btn btn-light ${item.id === props.activeBtn && 'ImageButton--active'}`}
                    onClick={() => {
                      props.updateHoles(item.config);
                      props.setActiveBtn(item.id);
                    }}
                  >
                    <span className={item.img} />
                  </button>
                </Tooltip>
              </li>
              ))}
            </ul>
          ) }

          { (props.screw.count.m === 2 && props.screw.count.n === 2) && (
            <ul className="inline-list">
              {buttonsSecond.map(item => (
              <li key={item.id}>
                <Tooltip content={getTooltip(item.tooltip)}>
                  <button
                    className={`btn btn-light ${item.id === props.activeBtn && 'ImageButton--active'}`}
                    onClick={() => {
                      props.updateHoles(item.config);
                      props.setActiveBtn(item.id);
                    }}
                  >
                    <span className={item.img} />
                  </button>
                </Tooltip>
              </li>
              ))}
            </ul>
          ) }
        </div>
      ) || (
        <div>
          {APP_TEXTS.SLOTTED_HOLES_DESCRIPTION.Content}
        </div>
      ) }

    </section>
  </div>
);

const mapState = state => ({
  screw: state.options.screw,
  type: state.options.panel.type,

  activeBtn: state.selectors.dimension[state.main.appType].slottedHoles.activeBtn
});

const mapDispatch = dispatch => ({
  updateHoles: value => dispatch(setScrewOptions({ types: value })),

  setActiveBtn: id => dispatch(setSlottedHolesActiveBtn(id))
});

export default connect(mapState, mapDispatch)(SlottedHoles);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/SlottedHoles/index.js